import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import tokenService from '../../utils/tokenService';
import { useFeatureFlagsFromContext } from '../../launchdarkly';
import {
  fetchUserInfoFromToken,
  setUserId,
} from '../../redux/slices/userSlice';

/**
 * Component that handles JWT token refresh
 * This component doesn't render anything, it just initializes the token refresh service
 */
const TokenRefreshHandler = () => {
  const dispatch = useDispatch();
  const flags = useFeatureFlagsFromContext();
  const oktaSsoAuthEnabled = flags?.oktaSsoAuth || false;
  console.log('oktaSsoAuthEnabled - TokenRefreshHandler', oktaSsoAuthEnabled);

  useEffect(() => {
    // Set up callbacks for the token service
    // For SSO auth, use fetchUserInfoFromToken which works with HttpOnly cookies
    // For JWT auth, use the legacy fetchUserInfo
    tokenService.setCallbacks(
      () => dispatch(fetchUserInfoFromToken()), // onUserInfoUpdate - works for both SSO and JWT
      userId => dispatch(setUserId(userId)) // onUserIdUpdate
    );

    // Initialize the token service when the component mounts
    // Pass the oktaSsoAuth feature flag to control cookie checking
    tokenService.initialize(oktaSsoAuthEnabled);

    // Clean up the token service when the component unmounts
    return () => {
      tokenService.cleanup();
    };
  }, [dispatch, oktaSsoAuthEnabled]);

  // This component doesn't render anything
  return null;
};

export default TokenRefreshHandler;
